import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
import { useEffect } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import HelpIcon from '@mui/icons-material/Help';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';

export default function GroupCalllistDetails({ data, additionalProps }) {
  const [originsArray, setOriginsArray] = useState([]);

  const report = additionalProps?.report;

  useEffect(() => {
    if (data && data.origins) {
      const entries = Object.entries(data.origins);

      if (report) {
        const entriesWithData = entries.map(([key, value]) => {
          const reportUserAndGroups = [
            ...report.data.users,
            ...report.data.groups,
          ];

          const matchingEntry = reportUserAndGroups.find(
            (entry) =>
              entry?.accountId === Number(key) ||
              entry?.starfaceId === Number(key),
          );

          return {
            name: matchingEntry
              ? matchingEntry.firstName
                ? `${matchingEntry.firstName} ${matchingEntry.lastName}`
                : matchingEntry.name
              : key,
            accountId: key,
            count: value,
            type: matchingEntry
              ? matchingEntry.firstName
                ? 'user'
                : 'group'
              : 'unknown',
          };
        });

        const sortedEntries = entriesWithData.sort((a, b) => b.count - a.count);

        console.log('sortedEntries', sortedEntries);

        setOriginsArray(sortedEntries);
        return;
      }
    }
  }, [data]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 2,
        overflowY: 'auto',
      }}
    >
      <Typography variant="h6" gutterBottom fontWeight="bold">
        Herkunft der Weiterleitungen an die Gruppe {data.name}
      </Typography>

      {originsArray.length === 0 && (
        <Box>
          <Typography variant="body1">
            Keine Weiterleitungen in diesem Zeitraum.
          </Typography>
        </Box>
      )}

      {originsArray.length > 0 && (
        <Box>
          <List
            sx={{
              width: '90%',
            }}
            aria-labelledby="nested-list-subheader"
          >
            <ListItem key={origin.accountId} sx={{ p: 0 }}>
              <ListItemAvatar>
                <Avatar>
                  <PhoneCallbackIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Direkte Anrufe"
                secondary={`Anrufe, die direkt an die Gruppe gingen.`}
              />
              {data.calls.directRinging}
            </ListItem>
            <Divider />
            {originsArray.map((origin, index) => (
              <Box key={origin.accountId}>
                <ListItem key={origin.accountId} sx={{ p: 0 }}>
                  <ListItemAvatar>
                    <Avatar>
                      {origin.type === 'user' ? (
                        <PersonIcon />
                      ) : origin.type === 'group' ? (
                        <GroupsIcon />
                      ) : (
                        <HelpIcon />
                      )}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={origin.name}
                    secondary={`Starface ID: ${origin.accountId} `}
                  />
                  {origin.count}
                </ListItem>
                {index < originsArray.length - 1 && <Divider />}
              </Box>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
}
